import bannerImg3 from '../images/final-banner-snowhite.svg';
import bannerImg5 from '../images/final-banner-cinderalla.svg';
import bannerImg2 from '../images/final-banner-mermaid.svg';
import bannerImg1 from '../images/final-banner-sleep.svg';
import bannerImg6 from '../images/final-banner-king.svg';
import bannerImg4 from '../images/final-banner-redshoes.svg';

import figureImg3 from '../images/final-princess-snowhite.svg';
import figureImg5 from '../images/final-princess-cinderalla.svg';
import figureImg2 from '../images/final-princess-mermaid.svg';
import figureImg1 from '../images/final-princess-sleep.svg';
import figureImg6 from '../images/final-princess-king.svg';
import figureImg4 from '../images/final-princess-redshoes.svg';

export const banners = {
  bannerImg1,
  bannerImg2,
  bannerImg3,
  bannerImg4,
  bannerImg5,
  bannerImg6
};

export const figures = {
  figureImg1,
  figureImg2,
  figureImg3,
  figureImg4,
  figureImg5,
  figureImg6
};



// WEBPACK FOOTER //
// ./app/utils/image-handler.js